import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2ae215ce&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae215ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae215ce')) {
      api.createRecord('2ae215ce', component.options)
    } else {
      api.reload('2ae215ce', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2ae215ce&scoped=true&", function () {
      api.rerender('2ae215ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kGV9wU57yceE/JS/comp/Accordion.vue"
export default component.exports